import React from "react";

/* Notification bell. Inherits currentColor. Lives here rather than inside the top bar: the Following screen's update strip needs the same mark, and a second... */
export const BellIcon = ({ size = 18, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path
      d="M18 8a6 6 0 10-12 0c0 7-3 8-3 8h18s-3-1-3-8"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.7 21a2 2 0 01-3.4 0"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
  </svg>
);

export default BellIcon;
